/**
 * @generated SignedSource<<49e9a0b32839ff426b8a2b72a3aee890>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type OrderDirection = "ASC" | "DESC" | "%future added value";
export type OrganizationMembershipAssetUsagesOrderBy = "name" | "watch_progress" | "%future added value";
export type AdminMembersReportAssetUsagesTablePaginationQuery$variables = {
  after?: string | null;
  before?: string | null;
  direction?: OrderDirection | null;
  excludeProductLevel?: boolean | null;
  first?: number | null;
  id: string;
  last?: number | null;
  memberHasWatched?: boolean | null;
  memberOrganizationMembershipId: string;
  orderBy?: OrganizationMembershipAssetUsagesOrderBy | null;
  productIds?: ReadonlyArray<string> | null;
};
export type AdminMembersReportAssetUsagesTablePaginationQuery$data = {
  readonly node: {
    readonly " $fragmentSpreads": FragmentRefs<"AdminMembersReportAssetUsagesTable_PaginationFragment">;
  } | null;
};
export type AdminMembersReportAssetUsagesTablePaginationQuery = {
  response: AdminMembersReportAssetUsagesTablePaginationQuery$data;
  variables: AdminMembersReportAssetUsagesTablePaginationQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "after"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "before"
},
v2 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "direction"
},
v3 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "excludeProductLevel"
},
v4 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "first"
},
v5 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "id"
},
v6 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "last"
},
v7 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "memberHasWatched"
},
v8 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "memberOrganizationMembershipId"
},
v9 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "orderBy"
},
v10 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "productIds"
},
v11 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "id"
  }
],
v12 = {
  "kind": "Variable",
  "name": "after",
  "variableName": "after"
},
v13 = {
  "kind": "Variable",
  "name": "before",
  "variableName": "before"
},
v14 = {
  "kind": "Variable",
  "name": "direction",
  "variableName": "direction"
},
v15 = {
  "kind": "Variable",
  "name": "excludeProductLevel",
  "variableName": "excludeProductLevel"
},
v16 = {
  "kind": "Variable",
  "name": "first",
  "variableName": "first"
},
v17 = {
  "kind": "Variable",
  "name": "last",
  "variableName": "last"
},
v18 = {
  "kind": "Variable",
  "name": "memberHasWatched",
  "variableName": "memberHasWatched"
},
v19 = {
  "kind": "Variable",
  "name": "orderBy",
  "variableName": "orderBy"
},
v20 = {
  "kind": "Variable",
  "name": "productIds",
  "variableName": "productIds"
},
v21 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v23 = [
  (v12/*: any*/),
  (v13/*: any*/),
  (v14/*: any*/),
  (v15/*: any*/),
  (v16/*: any*/),
  (v17/*: any*/),
  (v18/*: any*/),
  (v19/*: any*/),
  (v20/*: any*/)
],
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "totalCount",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v26 = [
  (v25/*: any*/),
  (v22/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v5/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "AdminMembersReportAssetUsagesTablePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "args": [
              (v12/*: any*/),
              (v13/*: any*/),
              (v14/*: any*/),
              (v15/*: any*/),
              (v16/*: any*/),
              (v17/*: any*/),
              (v18/*: any*/),
              {
                "kind": "Variable",
                "name": "memberOrganizationMembershipId",
                "variableName": "memberOrganizationMembershipId"
              },
              (v19/*: any*/),
              (v20/*: any*/)
            ],
            "kind": "FragmentSpread",
            "name": "AdminMembersReportAssetUsagesTable_PaginationFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/),
      (v2/*: any*/),
      (v3/*: any*/),
      (v4/*: any*/),
      (v6/*: any*/),
      (v7/*: any*/),
      (v8/*: any*/),
      (v9/*: any*/),
      (v10/*: any*/),
      (v5/*: any*/)
    ],
    "kind": "Operation",
    "name": "AdminMembersReportAssetUsagesTablePaginationQuery",
    "selections": [
      {
        "alias": null,
        "args": (v11/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v21/*: any*/),
          (v22/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": (v23/*: any*/),
                "concreteType": "AssetUsageNodeConnection",
                "kind": "LinkedField",
                "name": "assetUsages",
                "plural": false,
                "selections": [
                  (v24/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "AssetUsageNodeEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "cursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "AssetUsage",
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v22/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Asset",
                            "kind": "LinkedField",
                            "name": "asset",
                            "plural": false,
                            "selections": (v26/*: any*/),
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "Content",
                            "kind": "LinkedField",
                            "name": "content",
                            "plural": false,
                            "selections": [
                              (v25/*: any*/),
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "type",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "contentLabelId",
                                "storageKey": null
                              },
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ContentUsageNodeConnection",
                                "kind": "LinkedField",
                                "name": "usages",
                                "plural": false,
                                "selections": [
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ContentUsageNodeEdge",
                                    "kind": "LinkedField",
                                    "name": "edges",
                                    "plural": true,
                                    "selections": [
                                      {
                                        "alias": null,
                                        "args": null,
                                        "concreteType": "ContentUsage",
                                        "kind": "LinkedField",
                                        "name": "node",
                                        "plural": false,
                                        "selections": [
                                          (v22/*: any*/),
                                          {
                                            "alias": null,
                                            "args": null,
                                            "kind": "ScalarField",
                                            "name": "entity",
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Product",
                                            "kind": "LinkedField",
                                            "name": "product",
                                            "plural": false,
                                            "selections": (v26/*: any*/),
                                            "storageKey": null
                                          },
                                          {
                                            "alias": null,
                                            "args": null,
                                            "concreteType": "Content",
                                            "kind": "LinkedField",
                                            "name": "module",
                                            "plural": false,
                                            "selections": [
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "isCurriculumModule",
                                                "storageKey": null
                                              },
                                              {
                                                "alias": null,
                                                "args": null,
                                                "kind": "ScalarField",
                                                "name": "isCollectionModule",
                                                "storageKey": null
                                              },
                                              (v25/*: any*/),
                                              (v22/*: any*/)
                                            ],
                                            "storageKey": null
                                          }
                                        ],
                                        "storageKey": null
                                      }
                                    ],
                                    "storageKey": null
                                  },
                                  (v24/*: any*/)
                                ],
                                "storageKey": null
                              },
                              (v22/*: any*/)
                            ],
                            "storageKey": null
                          },
                          {
                            "alias": null,
                            "args": [
                              {
                                "kind": "Variable",
                                "name": "organizationMembershipId",
                                "variableName": "memberOrganizationMembershipId"
                              }
                            ],
                            "concreteType": "AssetVideoProgress",
                            "kind": "LinkedField",
                            "name": "highestAssetVideoProgress",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "kind": "ScalarField",
                                "name": "maxPercent",
                                "storageKey": null
                              },
                              (v22/*: any*/)
                            ],
                            "storageKey": null
                          },
                          (v21/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "PageInfoObjectType",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "endCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "startCursor",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasNextPage",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "hasPreviousPage",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              },
              {
                "alias": null,
                "args": (v23/*: any*/),
                "filters": [
                  "productIds",
                  "excludeProductLevel",
                  "memberHasWatched",
                  "orderBy",
                  "direction"
                ],
                "handle": "connection",
                "key": "AdminMembersReportAssetUsagesTable_assetUsages",
                "kind": "LinkedHandle",
                "name": "assetUsages"
              }
            ],
            "type": "OrganizationMembership",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "6559691a776c6c30d985e71b92f64620",
    "id": null,
    "metadata": {},
    "name": "AdminMembersReportAssetUsagesTablePaginationQuery",
    "operationKind": "query",
    "text": "query AdminMembersReportAssetUsagesTablePaginationQuery(\n  $after: String\n  $before: String\n  $direction: OrderDirection\n  $excludeProductLevel: Boolean\n  $first: Int\n  $last: Int\n  $memberHasWatched: Boolean\n  $memberOrganizationMembershipId: ID!\n  $orderBy: OrganizationMembershipAssetUsagesOrderBy\n  $productIds: [ID!]\n  $id: ID!\n) {\n  node(id: $id) {\n    __typename\n    ...AdminMembersReportAssetUsagesTable_PaginationFragment_4Ey89W\n    id\n  }\n}\n\nfragment AdminMembersReportAssetUsagesTableRowFragment_1Enw86 on AssetUsage {\n  id\n  asset {\n    name\n    id\n  }\n  content {\n    name\n    type\n    contentLabelId\n    usages {\n      edges {\n        node {\n          id\n          entity\n          product {\n            name\n            id\n          }\n          module {\n            isCurriculumModule\n            isCollectionModule\n            name\n            id\n          }\n        }\n      }\n      totalCount\n    }\n    id\n  }\n  highestAssetVideoProgress(organizationMembershipId: $memberOrganizationMembershipId) {\n    maxPercent\n    id\n  }\n}\n\nfragment AdminMembersReportAssetUsagesTable_PaginationFragment_4Ey89W on OrganizationMembership {\n  id\n  assetUsages(first: $first, after: $after, last: $last, before: $before, productIds: $productIds, excludeProductLevel: $excludeProductLevel, memberHasWatched: $memberHasWatched, orderBy: $orderBy, direction: $direction) {\n    totalCount\n    edges {\n      cursor\n      node {\n        id\n        ...AdminMembersReportAssetUsagesTableRowFragment_1Enw86\n        __typename\n      }\n    }\n    pageInfo {\n      endCursor\n      startCursor\n      hasNextPage\n      hasPreviousPage\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "535fd0daee8610fae669414b6d2a23c0";

export default node;
